module.exports = __webpack_public_path__ + "static/media/who_front_bg.bd5d79ac.png";